// extracted by mini-css-extract-plugin
export default {"partner__without_img":"PartnersName_partner__without_img__eg7fk"};